// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"ded4d222","outerContainer":"ccc3525b","secondaryToolbar":"f1d97ffd","doorHangerRight":"be0ac8fb","toolbarContainer":"_15ff3572","toolbarViewerMiddle":"d5cf961c","progressBar":"_72d38ea4","back-to-application":"da949962","root":"_1e3fb8f2","singleMonthRoot":"_217fd7ad","valueWrapper":"_0d36a5d0","metric":"_7065e185","value":"a2b90ca0","rightSideWrapper":"a217e05c","date":"cb3ce360","dataSourceTitle":"_399a8fb1","dataHistoricList":"a8fc5d25"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/Chart/SinglePointValueModal/index.styl
// module id = 5040
// module chunks = 39